export default __webpack_public_path__ + "static/piconft-icon-f600abee8faabc032c19795f777b228e.png";